import React from "react";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { useGlobalSettings } from "../GlobalSettingsContext";
import { HEADER_COLORS, HEADER_TEXT_COLOR } from "../theme";

const AppHeader: React.FC = () => {
  const {
    settings: { themeMode },
    updateSettings,
  } = useGlobalSettings();

  return (
    <AppBar
      position="absolute"
      sx={{
        color: HEADER_TEXT_COLOR,
        backgroundColor: HEADER_COLORS[themeMode],
        boxShadow: "0 2px 12px rgba(20, 14, 8, 0.35)",
        // Extend the bar's brown fill up behind the iOS status bar and push the
        // toolbar below it so the clock/battery overlay the bar, not white space.
        paddingTop: "env(safe-area-inset-top)",
      }}
    >
      <Toolbar>
        <Typography
          variant="h6"
          noWrap
          component="h1"
          sx={{ fontWeight: 700, letterSpacing: "0.01em" }}
        >
          Fretboard Adventures
        </Typography>
        <IconButton
          aria-label={themeMode === "dark" ? "switch to light mode" : "switch to dark mode"}
          onClick={() => updateSettings({ themeMode: themeMode === "dark" ? "light" : "dark" })}
          sx={{ color: HEADER_TEXT_COLOR, marginLeft: "auto" }}
        >
          {themeMode === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
